import api from './api';

const menuItemService = {
  getAllMenuItems: async (params = {}) => {
    const response = await api.get('/menu-items', { params });
    return response.data;
  },

  getMenuItemById: async (id) => {
    const response = await api.get(`/menu-items/${id}`);
    return response.data;
  },

  getMenuItemStats: async () => {
    const response = await api.get('/menu-items/stats');
    return response.data;
  },

  createMenuItem: async (data) => {
    const response = await api.post('/menu-items', data);
    return response.data;
  },

  updateMenuItem: async (id, data) => {
    const response = await api.put(`/menu-items/${id}`, data);
    return response.data;
  },

  deleteMenuItem: async (id) => {
    const response = await api.delete(`/menu-items/${id}`);
    return response.data;
  }
};

export default menuItemService;
